export { default } from './ClassNotes';
